import React from 'react';

import {Button, Modal} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Assets from '../../../helpers/assets';
import Colors from '../../../helpers/Colors';
import {ModalStyles} from './CubbyModalStyles';

export function CubbyConflictDetectedModal({isOpen, onChooseAnotherCubby, onClose}) {
    const style = ModalStyles();

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableBackdropClick
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        >
            <div className={style.container}>
                <IconButton className={style.closeButton} onClick={onClose}><CloseIcon/></IconButton>
                <div className={style.body}>
                    <div className={style.leftPanel}>
                        <img src={Assets.conflictDetected.default} alt="conflict detected"/>
                    </div>
                    <div className={style.rightPanel}>
                        <div className={style.titleText}>A conflict detected</div>
                        <div className={style.subText}>This cubby is already assigned to another order.</div>
                        <div className={style.buttonContainer}>
                            <Button type="submit"
                                    variant="outlined"
                                    fullWidth
                                    style={{color: Colors.grubtechBlue, borderColor: Colors.grubtechBlue}}
                                    onClick={() => onChooseAnotherCubby()}
                                    className={style.button}>Choose Another Cubby
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}